/**
 * NAV-státusz badge — közös helper (DRY, #534 follow-up, R-4 POS NAV-chip)
 *
 * A POS-checkout-success (SalesPOSPage) és a sale-részletek (SalesDetailPage)
 * UGYANAZT a NAV-státusz-chipet rendereli a közös `navStatus.*` i18n-namespace +
 * `NAV_STATUSES` config alapján. Korábban a `getNavStatusBadge` inline élt a
 * SalesDetailPage-ben — kiemelve, hogy mindkét fogyasztó byte-azonos badge-et adjon.
 */

/* eslint-disable react-refresh/only-export-components --
   DRY-helper modul: a getNavStatusBadge (JSX) + a poll-helperek (isTerminalNavStatus,
   TERMINAL_NAV_STATUSES) szándékosan együtt élnek — ez nem Fast-Refresh-elt komponens-fájl,
   hanem közös sales NAV-státusz util (SalesDetailPage + SalesPOSPage fogyasztja). */
import type { TranslationParams } from '@kgc/i18n';
import { NAV_STATUSES } from '../pages/invoices/mock-data';

/** A `@kgc/i18n` `t` aláírása — közvetlenül átadható a useTranslation()-ből. */
type TFn = (key: string, params?: TranslationParams) => string;

/**
 * NAV-státusz badge renderelése. `null`-t ad ha nincs státusz (a hívó dönti el
 * mit mutat helyette). A `t`-t paraméterként kapja, hogy pure/SSR-barát maradjon.
 */
export function getNavStatusBadge(navStatus: string | undefined, t: TFn) {
  if (!navStatus) return null;
  const config = NAV_STATUSES.find(s => s.value === navStatus.toUpperCase());
  return (
    <span className={`rounded-full px-3 py-1 text-sm font-medium ${config?.color ?? ''}`}>
      {config ? t(config.labelKey) : navStatus}
    </span>
  );
}

/** Terminál (véglegesedett) NAV-státuszok — ezeknél a POS-poll leáll. */
export const TERMINAL_NAV_STATUSES = ['ACCEPTED', 'REJECTED', 'ERROR'] as const;

/** Igaz, ha a NAV-státusz már nem változik tovább (poll-stop feltétel). */
export function isTerminalNavStatus(navStatus: string | undefined): boolean {
  if (!navStatus) return false;
  return (TERMINAL_NAV_STATUSES as readonly string[]).includes(navStatus.toUpperCase());
}
